export default "__VITE_ASSET__aa01debe__"